import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-53af0438")

_pushScopeId("data-v-53af0438")
const _hoisted_1 = {
  class: "display-flex",
  width: "100%"
}
const _hoisted_2 = { class: "info-item-bottom" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", {
  style: {"color":"#ff4949"},
  class: "margin-right5px"
}, "*", -1)
const _hoisted_4 = { class: "font-size13px color-gray info-item-bottom" }
const _hoisted_5 = {
  key: 0,
  class: "info-item-bottom font-size12px",
  style: {"color":"#f56c6c"}
}
const _hoisted_6 = {
  key: 0,
  class: "status-off"
}
const _hoisted_7 = {
  key: 1,
  class: "status-on"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "height30px" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_list = _resolveComponent("list")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_sec_date_picker = _resolveComponent("sec-date-picker")
  const _component_el_form = _resolveComponent("el-form")
  const _component_dialog_shell = _resolveComponent("dialog-shell")
  const _component_submit_notice = _resolveComponent("submit-notice")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_dialog_shell, {
      title: _ctx.dialogTitle,
      onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('close'))),
      onSubmit: _ctx.changeShowSubmitNotice
    }, {
      default: _withId(() => [
        _createVNode(_component_el_form, {
          "label-position": _ctx.$formLabelPosition,
          rules: _ctx.rules,
          model: _ctx.initForm,
          ref: "form"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.TabelUpdateBoxVersion,
              prop: "Version"
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_1, [
                  _createVNode(_component_cus_select, {
                    class: "flex1 margin-right20px",
                    modelValue: _ctx.initForm.Model,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.initForm.Model = $event)),
                    onChange: _ctx.changeVersionOptions,
                    placeholder: _ctx.$wordList.ProperAllTextChooseModel,
                    filter: ""
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modelOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_cus_option, {
                          key: item,
                          value: item.VersionName,
                          label: item.VersionName
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange", "placeholder"]),
                  _createVNode(_component_cus_select, {
                    class: "flex1 margin-right20px",
                    modelValue: _ctx.initForm.Version,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.initForm.Version = $event)),
                    placeholder: _ctx.$wordList.ProperAllTextChooseVersion,
                    filter: ""
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.versionOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_cus_option, {
                          key: item,
                          value: item.Version,
                          label: item.Version
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.ChangeLog
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.changeLog,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeLog = $event)),
                  disabled: "",
                  rows: "5",
                  "auto-complete": "off",
                  type: "textarea"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode("p", _hoisted_2, [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_ctx.$wordList.TabelUpdateBoxDevice), 1)
            ]),
            _createVNode("p", _hoisted_4, "*" + _toDisplayString(_ctx.$wordList.TabelUpdateBoxTips), 1),
            (_ctx.showDeviceTips)
              ? (_openBlock(), _createBlock("p", _hoisted_5, _toDisplayString(_ctx.$wordList.TabelKeyDevice), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_el_input, {
              class: "width250px",
              placeholder: _ctx.inputPlaceHolder,
              modelValue: _ctx.listRequestData.param.searchValue,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.listRequestData.param.searchValue = $event))
            }, null, 8, ["placeholder", "modelValue"]),
            _createVNode(_component_list, {
              class: "margin-top10px height220px overflow-auto",
              headers: _ctx.header,
              requestData: _ctx.listRequestData,
              action: false,
              update: _ctx.updateToList,
              selectedItem: _ctx.initChoose,
              isClearCheck: false,
              showCheck: "OnlyCheck",
              onMultipleSelect: _ctx.getSelectDevices
            }, {
              StatusSlot: _withId((data) => [
                (data.scope.Status === _ctx.update.statusOff)
                  ? (_openBlock(), _createBlock("div", _hoisted_6))
                  : _createCommentVNode("", true),
                (data.scope.Status === _ctx.update.statusOn)
                  ? (_openBlock(), _createBlock("div", _hoisted_7))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["headers", "requestData", "update", "selectedItem", "onMultipleSelect"]),
            _hoisted_8,
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.TabelUpdateBoxTime,
              prop: "UpdateTimeDate"
            }, {
              default: _withId(() => [
                (_ctx.updateType=='add')
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_el_radio, {
                        modelValue: _ctx.updateTimeType,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateTimeType = $event)),
                        label: "0"
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$wordList.TabelUpdateBoxUpgradeRightNow), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_radio, {
                        modelValue: _ctx.updateTimeType,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateTimeType = $event)),
                        label: "1"
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$wordList.TabelUpdateBoxSpecificTime), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      (_ctx.updateTimeType==_ctx.update.updateSpecificTime)
                        ? (_openBlock(), _createBlock(_component_sec_date_picker, {
                            key: 0,
                            modelValue: _ctx.initForm.UpdateTimeDate,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.initForm.UpdateTimeDate = $event)),
                            type: "datetime"
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createBlock(_component_sec_date_picker, {
                      key: 1,
                      modelValue: _ctx.initForm.UpdateTimeDate,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.initForm.UpdateTimeDate = $event))
                    }, null, 8, ["modelValue"]))
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["label-position", "rules", "model"])
      ]),
      _: 1
    }, 8, ["title", "onSubmit"]),
    (_ctx.showSubmitNotice)
      ? (_openBlock(), _createBlock(_component_submit_notice, {
          key: 0,
          "change-log": _ctx.changeLog,
          onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showSubmitNotice=false)),
          onSubmit: _ctx.submit
        }, null, 8, ["change-log", "onSubmit"]))
      : _createCommentVNode("", true)
  ]))
})